import axios from "axios";
import {usePaging} from "@/modules/reader/book/paging";
import {useMuteRoleControl} from "@/modules/reader/karaoke/muteRoleControl";
import AbstractAnnotations from "@/modules/reader/annotations/AbstractAnnotations";

class PlayMultiBlockBlockAnnotation extends AbstractAnnotations{

    static get TYPE() {
        return "playMultipleBlock"
    }

    constructor(builder) {

        super();
        this.annotations.domPos = builder.domPos;

        let aimPageBtnIds = [];
        let aimPageIndices = [];
        let btnIdPageMapping = [];

        if (!this.annotationTypes.includes( PlayMultiBlockBlockAnnotation.TYPE)) {
            this.annotationTypes.push(PlayMultiBlockBlockAnnotation.TYPE);
        }

        this.annotations.isPlayMultiPageBlockBtn = true;

        for (let [key, value] of Object.entries(builder.meta)) {

            if (key === "icon") {
                super.setAnnotations({"iconSrc": value});
            } else if (key === "aimPageBtnId") {
                aimPageBtnIds = value.split(",")
            } else if (key === "aimPageIndex") {
                aimPageIndices = value.split(",")
                aimPageIndices = aimPageIndices.map(el => {
                    return parseInt(el)
                });
                super.setAnnotations({"pageRanges": aimPageIndices});
            }
        }

        for (let i=0; i< aimPageIndices.length; i++){
            btnIdPageMapping.push({
                aimPageIndex:aimPageIndices[i],
                aimPageBtnId: aimPageBtnIds[i]
            })
        }

        super.setAnnotations({"btnIdPageMapping": btnIdPageMapping});

    }

}

export default PlayMultiBlockBlockAnnotation